import type { PetAction, PetCare } from './petCare';
export interface PetTemperament { irritation: number; lastCarry: number; lastRefusal: number }
export type PetIntent = PetAction | 'carry';
export type PetRefusal = 'full' | 'tired' | 'hungry' | 'unwell' | 'upset' | 'space';
export const REFUSAL_TEXT: Record<PetRefusal, { title: string; help: string; detail?: string }> = {
  full: { title: 'Я уже наелся', help: 'Миска подождёт. Лучше погладьте меня или посидите рядом.' },
  tired: { title: 'Мне бы поспать', help: 'Сил мало. Уложите меня в домик и дайте восстановиться.' },
  hungry: { title: 'Сначала перекусим?', help: 'На игру пока нет сил. Предложите еду.' },
  unwell: { title: 'Хочется тихой заботы', help: 'Отдых, еда и расчёсывание помогут прийти в себя.' },
  upset: { title: 'Я сейчас не в настроении', help: 'Не торопите: «Побыть рядом» поможет снова довериться.' },
  space: { title: 'Пока не хочу на руки', detail: 'Несколько переносов подряд', help: 'Вы несколько раз перенесли питомца подряд. Дайте ему спокойно отдохнуть или выберите «Побыть рядом».' },
};
export const defaultPetTemperament = (): PetTemperament => ({ irritation: 0, lastCarry: 0, lastRefusal: 0 });
export function normalizePetTemperament(value: unknown, now = Date.now()): PetTemperament {
  const raw = value && typeof value === 'object' ? value as Record<string, unknown> : {};
  const finite = (key: string, max: number) => typeof raw[key] === 'number' && Number.isFinite(raw[key]) ? Math.max(0, Math.min(max, raw[key])) : 0;
  return { irritation: finite('irritation', 100), lastCarry: finite('lastCarry', now), lastRefusal: finite('lastRefusal', now) };
}
/** Причины предсказуемы; базовая забота всегда оставляет путь к восстановлению. */
export function petRefusal(action: PetIntent, care: PetCare, temperament: PetTemperament, asleep = false): PetRefusal | null {
  if (action === 'comfort' || action === 'rest' || asleep && action === 'carry') return null;
  if (action === 'feed') return care.satiety >= 92 ? 'full' : null;
  if (asleep && care.energy < 22 || action === 'wake' && care.energy < 22) return 'tired';
  if (action === 'wake') return null;
  if (action === 'play' || action === 'bell' || action === 'toy') {
    if (care.energy < 25) return 'tired';
    if (care.satiety < 20) return 'hungry';
    if (care.health < 45) return 'unwell';
  }
  if (action === 'carry' && care.energy < 15) return 'tired';
  if (action === 'carry' && care.health < 45) return 'unwell';
  if (temperament.irritation >= 35) return 'space';
  if (care.mood < (action === 'carry' ? 35 : action === 'groom' ? 20 : 28)) return 'upset';
  return null;
}
